import Immutable from 'immutable';
import {
  FLAG_GETTING_MAINTENANCE_FAIL_MODES,
  GET_MAINTENANCE_FAIL_MODES,
  CLEAR_MAINTENANCE_FAIL_MODES,
  FLAG_MAINTENANCE_FAIL_MODE_ACTIVITY,
  CLEAR_MAINTENANCE_FAIL_MODE,
  GET_MAINTENANCE_FAIL_MODE,
  GET_MAINTENANCE_FAIL_MODE_ACTIVITIES,
  CLEAR_MAINTENANCE_FAIL_MODE_ACTIVITIES,
  FLAG_GETTING_MAINTENANCE_FAIL_MODE_ACTIVITIES,
} from '../../../actions/types/mechanical-maintenance';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),

  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),

  activities: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_MAINTENANCE_FAIL_MODES:
      return state.setIn(['all', 'loading'], payload);

    case GET_MAINTENANCE_FAIL_MODES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));

    case CLEAR_MAINTENANCE_FAIL_MODES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );

    case FLAG_MAINTENANCE_FAIL_MODE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );

    case GET_MAINTENANCE_FAIL_MODE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));

    case CLEAR_MAINTENANCE_FAIL_MODE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));

    case FLAG_GETTING_MAINTENANCE_FAIL_MODE_ACTIVITIES:
      return state.setIn(['activities', 'loading'], payload);

    case GET_MAINTENANCE_FAIL_MODE_ACTIVITIES:
      return state.setIn(['activities', 'content'], Immutable.List(payload));

    case CLEAR_MAINTENANCE_FAIL_MODE_ACTIVITIES:
      return state.setIn(['activities'], INITIAL_STATE.getIn(['activities']));

    default:
      return state;
  }
};
